const paymentinstTC = `### 付款指示 - 恆生銀行
#### 🔹 方法 1：銀行轉帳
銀行名稱：恆生銀行

帳戶號碼：769-305426-883

收款人名稱：Mutual Insurance Consultants Co.

#### 🔹 方法 2：FPS
FPS ID：160318267

FPS 名稱：Mutual Insurance Consultants Co.

請上傳交易證明以便進一步處理

**確保您的證明顯示**：
  - *交易 ID/參考號碼*
  - *日期和金額*
  - *發件人/收件人詳情*（為隱私部分遮蔽）
  - *銀行/平台名稱*（例如，銀行對賬單片段）
`;

export default paymentinstTC;